import type { talentPoolCopy } from '@/app/talent-pool/copy'
import type { TalentPoolFormDraft } from '@/app/talent-pool/talent-pool-store'

type ValidationCopy = typeof talentPoolCopy.validation

export const getPersonalStepErrors = (
  draft: TalentPoolFormDraft,
  validationCopy: ValidationCopy,
): Record<string, string> => {
  const errors: Record<string, string> = {}

  if (!draft.fullName.trim()) {
    errors.fullName = validationCopy.fullNameRequired
  }

  if (!draft.emailAddress.trim()) {
    errors.emailAddress = validationCopy.emailRequired
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft.emailAddress)) {
    errors.emailAddress = validationCopy.emailInvalid
  }

  if (!draft.phoneNumber.trim()) {
    errors.phoneNumber = validationCopy.phoneRequired
  }

  if (!draft.birthDate.trim()) {
    errors.birthDate = validationCopy.birthDateRequired
  }

  return errors
}

export const getPreferencesStepErrors = (
  draft: TalentPoolFormDraft,
  validationCopy: ValidationCopy,
): Record<string, string> => {
  const errors: Record<string, string> = {}

  if (draft.targetedRoles.length === 0) {
    errors.targetedRoles = validationCopy.targetedRolesRequired
  }

  if (!draft.expectedSalaryMin.trim() && !draft.expectedSalaryRange.trim()) {
    errors.expectedSalaryRange = validationCopy.salaryRequired
  }

  if (!draft.currentCity.trim()) {
    errors.currentCity = validationCopy.currentCityRequired
  }

  if (!draft.willingToRelocate) {
    errors.willingToRelocate = validationCopy.willingToRelocateRequired
  }

  if (!draft.status) {
    errors.status = validationCopy.statusRequired
  }

  return errors
}
